import template from './requestCardSimulationFamily.html';
import controller from './requestCardSimulationFamily.controller';
import './requestCardSimulationFamily.scss';

let requestCardSimulationFamilyComponent = {
  restrict: 'E',
  bindings: {
    loanSimulation: '<',
    onSelectLoan: '&',
    scrollToResults: '&',
    onModifyLoan: '&',
    itemSelected: '<',
    codeLoanSimulation: '<',
    family: '<',
    codeOption: '<',
    myCreditworthiness: '<',
    dataSimulation: '<',
    housingWitness: '<',
    simulationWitness: '<',
  },
  template,
  controller,
};

export default requestCardSimulationFamilyComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/requestCardSimulationFamily/requestCardSimulationFamily.component.js